import { CacheableDataObject } from './CacheableDataObject';
import { Users } from './UserCollection';
import { DateFormat } from '../components/DateFormat';

export default class PostGroupTopic extends CacheableDataObject {
	beforeConstruct() {
		this.last_activity = {};
	}
}

PostGroupTopic.prototype.dataLocationParsers = {
	sender: (topic, data) => {
		topic.sender = Users.update(data.sender);
	},
	time: (topic, data) => {
		topic.time = DateFormat.momentFromLadderTime(data.time);
	}
};
